// utils/localize.ts
export type OriginalDescription = {
    text: string | string[] | null;
    lang: string;
};

export function pickLocalized<T extends string | string[]>(
    fallback: T,
    original: OriginalDescription | null | undefined,
    currentLang: string
): T {
    if (original?.text && original.lang === currentLang) {
        return original.text as T;
    }
    return fallback;
}
